module.exports = __webpack_public_path__ + "img/serviceplanner-planning-parts-overlay-de.cd6df09c.webp";